/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class WellArchitectedFrameworkAssessmentRunQuestion {
    getFixupPrototypeFunction() { return WellArchitectedFrameworkAssessmentRunQuestion.fixupPrototype; }

    static newInstance(model: Partial<WellArchitectedFrameworkAssessmentRunQuestion>): WellArchitectedFrameworkAssessmentRunQuestion {
        let obj = Object.assign(new WellArchitectedFrameworkAssessmentRunQuestion(), model);
        WellArchitectedFrameworkAssessmentRunQuestion.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<WellArchitectedFrameworkAssessmentRunQuestion>): WellArchitectedFrameworkAssessmentRunQuestion {
        if (!model) return null;
        return WellArchitectedFrameworkAssessmentRunQuestion.newInstance(<WellArchitectedFrameworkAssessmentRunQuestion> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: WellArchitectedFrameworkAssessmentRunQuestion) {
        if (!obj) return;

        models.WellArchitectedFrameworkAssessmentRunQuestion.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: WellArchitectedFrameworkAssessmentRunQuestion): boolean {
        Object.setPrototypeOf(obj, WellArchitectedFrameworkAssessmentRunQuestion.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (typeof this.createdOn === "string") {
            this.createdOn = new Date(<string><any>this.createdOn);
        }
        if (typeof this.updatedOn === "string") {
            this.updatedOn = new Date(<string><any>this.updatedOn);
        }
        if (this.assessment_run_history) {
            models.RecordIdentity.fixupPrototype(this.assessment_run_history);
        }
        if (this.answers) {
            for (let val of this.answers) {
                models.WellArchitectedFrameworkAssessmentRunAnswer.fixupPrototype(val);
            }
        }
    }

    /**
     * ID of the Assessment run question
     */
    sysId: string;

    /**
     * Assessment run question created on
     */
    createdOn: Date;

    /**
     * Assessment run question created on
     */
    updatedOn: Date;

    /**
     * The entry in the Assessment Run History this question is for
     */
    assessment_run_history: models.RecordIdentity;

    /**
     * Identity of the Framework
     */
    framework_id: string;

    /**
     * Identity of the Pillar
     */
    pillar_id: string;

    /**
     * Identity of the Question
     */
    question_id: string;

    answers: Array<models.WellArchitectedFrameworkAssessmentRunAnswer>;

    /**
     * Sync failure reason
     */
    sync_failure_reason: string;

}
